import React, {useEffect} from 'react';
import PopUp from 'app/Components/Shared/Popup/PopUp';

const DarkPopUp = ({children, popUpProps, cleanupFunc}) => {

  useEffect(() => {
    return () => {
      if (cleanupFunc) {
        cleanupFunc();
      }
    };
  }, []);

  return (
    <div className='dark-popup'>
      <PopUp {...popUpProps}>{children}</PopUp>
    </div>
  );
};
export default DarkPopUp;
